import {
  TRANSACTION_RULE_FIELD_FILTER_REQUEST,
  TRANSACTION_RULE_FIELD_FILTER_REQUEST_SUCCESS,
  TRANSACTION_RULE_FIELD_FILTER_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const transactionRuleFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_RULE_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_RULE_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TRANSACTION_RULE_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default transactionRuleFilterFieldsReducer;
